// Shared constants and types to prevent circular dependencies

// Sheet name mappings
export const SHEET_MAPPINGS = {
  'dashboard': 'Dashboard Stats',
  'lead-requests': 'Lead Requests',
  'pipeline-leads': 'Pipeline',
  'call-leads': 'Leads',
  'whatsapp-leads': 'Leads',
  'email-leads': 'Leads',
  'pre-qualified': 'Pre-Qualified Leads',
  'qualified': 'Qualified Leads',
  'meetings': 'Meetings'
};

// Pipeline stages
export const PIPELINE_STAGES = [
  { id: 'engaged', name: 'Engaged', color: 'bg-blue-100 text-blue-800 border-blue-200', description: 'Lead interacted (clicked, replied generically)' },
  { id: 'interested', name: 'Interested', color: 'bg-orange-100 text-orange-800 border-orange-200', description: 'Lead showed genuine interest' },
  { id: 'qualified', name: 'Qualified', color: 'bg-purple-100 text-purple-800 border-purple-200', description: 'Lead met qualification criteria' },
  { id: 'meeting_booked', name: 'Meeting Booked', color: 'bg-indigo-100 text-indigo-800 border-indigo-200', description: 'Date & time of booked meeting visible' },
  { id: 'proposal_sent', name: 'Proposal Sent', color: 'bg-cyan-100 text-cyan-800 border-cyan-200', description: 'Proposal uploaded by Sales Agent or manually' },
  { id: 'closed_won', name: 'Closed Won', color: 'bg-green-100 text-green-800 border-green-200', description: 'Successfully converted leads' },
  { id: 'closed_lost', name: 'Closed Lost', color: 'bg-red-100 text-red-800 border-red-200', description: 'Not a fit or didn\'t proceed' }
];

// Pipeline stage names for updates
export const PIPELINE_STAGE_NAMES = [
  'Engaged',
  'Interested', 
  'Qualified',
  'Meeting Booked',
  'Proposal Sent',
  'Closed Won',
  'Closed Lost'
];

// Lead generation form constants
export const COUNTRIES = [
  'United Arab Emirates',
  'Saudi Arabia',
  'United States',
  'United Kingdom'
];

export const INDUSTRIES = [
  'Hospital & Health Care',
  'Hotels & Motels',
  'Restaurants',
  'Construction',
  'Manufacturing'
];

export const COMPANY_SIZES = [
  '1-10 employees',
  '11-50 employees',
  '51-200 employees',
  '200+ employees'
];

export const ALL_DM_TITLES = [
  'CEO',
  'CFO',
  'COO',
  'CTO',
  'General Manager',
  'Medical Director',
  'Procurement Director',
  'Operations Director',
  'Marketing Director',
  'Finance Director'
];

export const DM_TITLES_BY_INDUSTRY = {
  'Hospital & Health Care': ['CEO', 'CFO', 'COO', 'General Manager', 'Medical Director', 'Procurement Director', 'Operations Director', 'Finance Director'],
  'Hotels & Motels': ['CEO', 'CFO', 'COO', 'General Manager', 'Operations Director', 'Marketing Director', 'Finance Director'],
  'Restaurants': ['CEO', 'CFO', 'General Manager', 'Operations Director', 'Marketing Director', 'Procurement Director', 'Finance Director'],
  'Construction': ['CEO', 'CFO', 'COO', 'General Manager', 'Operations Director', 'Procurement Director', 'Finance Director'],
  'Manufacturing': ['CEO', 'CFO', 'COO', 'CTO', 'General Manager', 'Operations Director', 'Procurement Director', 'Finance Director']
};

export const QUANTITY_OPTIONS = [10, 100, 1000];

export const MAKE_WEBHOOK_URL = 'https://hook.eu2.make.com/41ex7lr0bvnzhiqgw1obgjvcq1tm7dk5';

// Webhook URLs for different actions
export const WEBHOOK_URLS = {
  'Call': 'https://hook.eu2.make.com/21qspu31ifmw0ecpyafdlangzqhspwpw',
  'Email': 'https://hook.eu2.make.com/15egt4qd6gyq27dhtqpjntwl5bjse7m6',
  'WhatsApp': 'https://hook.eu2.make.com/sbda6x1tyf0nfgl7qpctkyum38n70q9m'
};

// Demo booking webhook URL
export const DEMO_BOOKING_WEBHOOK_URL = 'https://hook.eu2.make.com/esryar9b1i8964fcsdtyysb1l3bbd1qa';

// Default stats structure
export const DEFAULT_STATS = {
  totalLeadsRequested: 0,
  totalInProgress: 0,
  totalDelivered: 0,
  preQualified: 0,
  qualified: 0,
  called: 0,
  whatsapped: 0,
  emailed: 0,
  conversionRate: 0
};